import PostEditor from '../components/PostPage/PostEditor';
import PostEditPanel from '../components/PostPage/PostEditPanel';
import socialMediaService from '../services/socialMediaCommonApi';
import { useFormOptions } from '../hooks/useFormOptions';
import { GenerateSocialMediaRequest } from '../types';
import PostHeader from '../components/PostPage/PostHeader';
import { useSearchParams } from 'react-router-dom';

const PostPage = () => {
  const { data, isLoading, isSuccess } = useFormOptions();
  const [searchParams] = useSearchParams();
  const platform = searchParams.get('name');

  const handleGenerate = async (formData: GenerateSocialMediaRequest) => {
    try {
      const result = await socialMediaService.generatePost(formData);
      console.log(result);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <main className="h-screen bg-background-main rounded-lg">
      {/* Desktop Layout - Hidden on mobile */}
      <div className="hidden lg:flex h-full gap-2">
        <div className="flex-1 bg-background flex flex-col h-full rounded-lg">
          <PostHeader />
          <div className="flex-1 overflow-auto">
            <PostEditor />
          </div>
        </div>

        {!isLoading && isSuccess && (
          <div className="w-[400px] bg-background rounded-lg">
            <PostEditPanel formOptions={data} onGenerate={handleGenerate} />
          </div>
        )}
      </div>

      {/* Mobile Layout - Hidden on desktop */}
      <div className="lg:hidden w-full h-full flex flex-col bg-background bg-cover">
        <PostHeader />
        {/* Hero Section */}
        <div className="w-full px-4 mt-1">
          <div className="text-text-primary space-y-5">
            <h1 className="text-2xl text-primary font-medium leading-tight">
              Welcome to {platform === 'linkedIn' ? 'LinkedIn' : 'X'} post generator, generate viral worthy content in seconds.
            </h1>
          </div>
        </div>

        {/* Form Section */}
        <div className="w-full px-4 pt-5 pb-6 bg-background">
          <div className="bg-background rounded-lg">
            {!isLoading && isSuccess && (
              <PostEditPanel formOptions={data} onGenerate={handleGenerate} />
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default PostPage;
